import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  savings: {
    defaultMessage: 'Save <b>{savingsAmount}</b> by choosing <span>{recommendationIcon}{recommendation}</span>',
    description: 'Savings',
    id: 'JGWORZ',
  },
  apply: {
    defaultMessage: 'Apply',
    description: 'Apply button text',
    id: '3f0OlQ',
  },
  appliedSavings: {
    defaultMessage: 'Saved <b>{savingsAmount}</b>!',
    description: 'Saved amount',
    id: '98CVeB',
  },
  undo: {
    defaultMessage: 'Undo',
    description: 'Undo button text',
    id: '71rz5Z',
  },
});
